::ng-deep .mews-score-low{color:#237804;font-weight:600}::ng-deep .mews-score-low-medium{color:#ad8b00;font-weight:600}::ng-deep .mews-score-medium{color:#ad6800;font-weight:600}::ng-deep .mews-score-high{color:#cf1322;font-weight:600}
/*# sourceMappingURL=vital-signs.component-AWH5QEUN.css.map */
